"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var emails_controller_1 = __importDefault(require("./emails.controller"));
var emails_html_1 = __importDefault(require("./emails.html"));
function getStudent($stateParams, UsersModel) {
    return UsersModel.getStudentByID($stateParams.userId).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["$stateParams", "UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.emails", {
        url: "/emails",
        controller: emails_controller_1.default,
        controllerAs: "vm",
        template: emails_html_1.default,
        resolve: {
            student: getStudent,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.emails", [])
    .config(config)
    .controller("AdminStudentViewEmailsController", emails_controller_1.default);
